export enum PronounForm {
    they, // [1]
    their, //[2]
    them, // [3]
    themselves, // [4]
    theirs, // [5]
    theyAre, // [6]
    theyHave, // [7]
    theyDo, // [8]
    theyGet, // [9]
    theyPark, // [10]
    theyCook, // [11]
    theyBuy, // [12]
    theyHate, // [13]
    theyWere, // [14]
    theyTry, // [15]
    theyTrust, // [16]
    theyThink, // [17]
    theyKnow, // [18]
    theyNeed, // [19]
    theyWalk, // [20]
    theyTalk, // [21]
    theyHit, // [22]
    theyForget, // [23]
    theyLike, // [24]
    theyBlow, // [25]
    theyAsk, // [26]
  }